export var AnalyticsStorageKeys = {
    RefContextType: 'ref_ctx_type',
    RefContextIndex: 'ref_ctx_index',
    RefContextLabel: 'ref_ctx_label',
    RefListID: 'ref_list_id',
    RefListIndex: 'ref_list_index',
};
export var AnalyticsContextTypes = {
    // Colourful pills at top and bottom of SRP. AKA "Discovery Bubbles"
    TopicPill: 'topic-pill',
    // Non-coloured pills with heading Related Search.
    RelatedSearchPill: 'related-search-pill',
    // Category pill rendered midst search results in a carousel.
    CategoryPill: 'category-pill',
    // Any of the category, price, size, medium filters.
    Filter: 'filter',
    // Change in sort order
    SortOrder: 'sort-order',
    TrendingTypeahead: 'trending-typeahead',
    PopularTypeahead: 'popular-typeahead',
    RecentTypeahead: 'recent-typeahead',
    FallbackTypeahead: 'fallback-typeahead',
    CategoriesTypeahead: 'categories-typeahead',
    ArtistsTypeahead: 'artists-typeahead',
    SearchBox: 'search-box',
};
export var AnalyticsItemsList = {
    AlsoAvailableOnModal: 'also_available_on_modal',
    OffsiteSimilarDesigns: 'offsite_similar_designs_carousel',
    AlsoAvailableOnCarousel: 'also_available_on_carousel',
    SimilarDesignsCarousel: 'similar_designs_carousel',
    SimilarDesignsATCDrawer: 'similar_designs_atc_drawer',
    ArtistAttributionCarousel: 'more_by_this_artist',
    SearchResultsPageResults: 'srp_results',
    LicensedProductsCarousel: 'licensed_products_carousel',
    ProductFeed: 'product_feed',
    UnknownCarousel: 'unknown_carousel',
    FanArtCarousel: 'fan_art_carousel',
    RecommendedWorksCarousel: 'recommended_works_carousel',
    RecommendedWorksPreviewCarousel: 'recommended_works_preview_carousel',
    RecentlyViewedCarousel: 'recently_viewed_carousel',
    TopicProductCarousel: 'topic_product_carousel',
    SimilarProductsCarousel: 'similar_products_carousel',
    SuggestedProductsCarousel: 'suggested_products_carousel',
    CategoryPageCarousel: 'category_page_carousel',
    ArtistShopResults: 'artist_shop_results',
    ArtistDesignResults: 'artist_design_results',
    FeaturedCollection: 'featured_collection',
    ProductPreview: 'product_preview',
    InventoryItemsCarousel: 'inventory_items_carousel',
    ProductCarousel: 'product_carousel',
    TabbedList: 'tabbed_list',
    ProductGrid: 'product_grid',
    Recommendations: 'recommendations',
    UserList: 'user_list',
};
export var AnalyticsItemsListIDNameMap = {
    offsite_similar_designs_carousel: 'Offsite Similar Designs Carousel',
    also_available_on_modal: 'Also Available On Modal',
    also_available_on_carousel: 'Also Available On Carousel',
    similar_designs_carousel: 'Similar Designs Carousel',
    similar_designs_atc_drawer: 'Similar Designs ATC Drawer',
    more_by_this_artist: 'More By This Artist',
    srp_results: 'SRP Results',
    licensed_products_carousel: 'Licensed Products Carousel',
    product_feed: 'Product Feed',
    unknown_carousel: 'Unknown Carousel',
    recommended_works_carousel: 'Recommended Works Carousel',
    recently_viewed_carousel: 'Recently Viewed Carousel',
    recommended_works_preview_carousel: 'Recommended Works Preview Carousel',
    topic_product_carousel: 'Topic Product Carousel',
    fan_art_carousel: 'Fan Art Carousel',
    similar_products_carousel: 'Similar Products Carousel',
    suggested_products_carousel: 'Suggested Products Carousel',
    artist_shop_results: 'Artist Shop Results',
    artist_design_results: 'Artist Design Results',
    featured_collection: 'Featured Collection',
    product_preview: 'Product Preview',
    inventory_items_carousel: 'Inventory Items Carousel',
    product_carousel: 'Product Carousel',
    tabbed_list: 'Tabbed List',
    product_grid: 'Product Grid',
    recommendations: 'Recommendations',
    user_list: 'User List',
    category_page_carousel: 'Category Page Carousel',
};
export var AnalyticsPageType = {
    ProductDetailsPage: 'pdp',
    SearchResultsPage: 'srp',
    Cart: 'cart',
    Checkout: 'check-out',
    GiftCard: 'gift-card',
    ArtistShop: 'artist-shop',
};
export var AnalyticsATCContext = {
    ProductDetailsPage: 'pdp_main',
    SearchResultsPage: 'srp_main',
    ArtistShopResultsPage: 'artist_shop_main',
};
export var AnalyticsPromotionCreativeSlot = {
    CartMessages: 'cart_messages',
    HeroBanner: 'hero_banner',
};
export var AnalyticsShippingPreference = {
    Standard: 'STANDARD',
    Express: 'EXPRESS',
};
export var AnalyticsPaymentType = {
    GooglePay: 'GooglePay',
    ApplePay: 'ApplePay',
    GooglePayExpress: 'GooglePay-express',
    ApplePayExpress: 'ApplePay-express',
    GooglePayExpressCartTray: 'GooglePay-express-cart-tray',
    ApplePayExpressCartTray: 'ApplePay-express-cart-tray',
    Stripe: 'Stripe',
    Paypal: 'Paypal',
    PaypalExpress: 'Paypal-express',
    PayPalExpressCartTray: 'Paypal-express-cart-tray',
    Klarna: 'BNPLKlarna',
    Afterpay: 'BNPLAfterPay',
};
export var AnalyticsContext = {
    QuantitySelector: 'quantity_selector',
};
export var SegmentPageType = {
    Product: 'Product',
    SearchResult: 'Search Results',
};
